var _path, _path2, _path3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAggridColumnsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#21201D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.65 5.5v-.92a.79.79 0 0 0-.79-.79h-4.745a.79.79 0 0 0-.79.79v11.07c0 .436.354.79.79.79h4.744a.79.79 0 0 0 .79-.79V14.5M13.487 3.79V6.5m0 9.94.013-2.94"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#21201D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M6.372 10.115a.79.79 0 0 1 .79.79v5.535a.79.79 0 0 1-.79.79H4.79a.79.79 0 0 1-.79-.79v-5.535a.79.79 0 0 1 .79-.79h1.582Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#21201D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5.582 7.742 4 6.161m3.163-.001L5.582 7.743M5.581 3v4.743"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    x: 14,
    y: 7,
    fill: "#8145B5",
    rx: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAggridColumnsActive);
export default __webpack_public_path__ + "static/media/aggrid-columns-active.3adbca03886cc6f11422e5928e478297.svg";
export { ForwardRef as ReactComponent };